<template>
  <header id="navbar" role="banner" class="navbar navbar-default navbar-fixed-top">
    <transition name="fade" mode="out-in">
      <div id="overlay" v-if="overlaySuperior" @click="toggleMenuSuperior()"></div>
      <div id="overlay" v-if="overlayLateral" @click="toggleMenuLateral()"></div>
    </transition>
    <div class="container">
      <div class="row hidden-xs hidden-sm">
        <div class="col-md-3">
          <router-link class="navbar-brand navbar-brand-topo" to="/" title="Início">Prefeitura de Santos</router-link>
        </div>
        <div class="col-md-9" v-show="autenticado">
          <button type="button" id="btn-menu-superior" class="navbar-toggle show" @click="toggleMenuSuperior()">
            <span class="sr-only">Menu lateral</span>
            <span class="btntxt">
              <span v-if="usuario">Olá {{ usuario }} &nbsp;</span>
              <span v-else>Olá {{ sshd }} &nbsp;</span>
              <span style="font-size: 0.9em" v-if="autenticados && autenticados.length > 1"
                v-tooltip.bottom="'Trocar Registro'">{{ funcionario.registroFormatado }} &nbsp;</span>
            </span>
            <span class="btnico">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </span>
          </button>
          <div class="upper-off-canvas">
            <div id="menu-superior">
              <h3>Usuário</h3>
              <ul id="main-menu" class="nav nav-pills nav-stacked">
                <li class="dropdown" v-if="autenticados && autenticados.length > 1">
                  <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                    aria-expanded="false" @click="paraBaixoTrocaRegistro = !paraBaixoTrocaRegistro">
                    Trocar Registro
                    <span class="to-the-right">
                      <i :class="downUp(paraBaixoTrocaRegistro)"></i>
                    </span>
                  </a>
                  <ul class="dropdown-menu" @click="toggleMenuSuperior()">
                    <li>
                      <a href="#" v-for="user in autenticados" :key="user.id" @click="trocaRegistro(user)">
                        {{ user.registroFormatado }}
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                  </ul>
                </li>

                <li @click="toggleMenuSuperior()">
                  <a href="https://egov.santos.sp.gov.br/websshd" target="_blank" rel="noopener">Trocar Senha</a>
                </li>
                <li @click="toggleMenuSuperior()">
                  <router-link :to="{ name: 'Conta' }">Meus Dados</router-link>
                </li>
                <li @click="toggleMenuSuperior()">
                  <router-link :to="{ name: 'Sair' }">Sair</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row visible-xs visible-sm">
      <div class="col-xs-8 col-sm-4">
        <router-link class="navbar-brand navbar-brand-topo" to="/" title="Início">Prefeitura de Santos</router-link>
      </div>
      <div class="col-xs-4 col-sm-8" v-show="autenticado">
        <button type="button" id="btn-menu-lateral" class="navbar-toggle show" @click="toggleMenuLateral()">
          <span class="sr-only">Menu lateral</span>
          <span class="btnico">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </span>
        </button>
        <div class="off-canvas">
          <div id="menu-lateral">
            <img src="../../assets/LogoXs.jpg" alt="Logo Central Servidor"
              style="margin-top: -15px; margin-left: -21px" />
            <h3>Aplicação</h3>
            <ul id="main-menu" class="nav navbar-nav">
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoDeclaracao = !paraBaixoDeclaracao">
                  Declarações
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoDeclaracao)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <router-link :to="{ name: 'DeclaracaoBens' }">Declaração de Bens</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'Dependente' }">Parceiro Econômico</router-link>
                  </li>
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoAvaliacao = !paraBaixoAvaliacao">
                  Avaliações
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoAvaliacao)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <router-link :to="{ name: 'Avaliacao' }">Avaliação Periódica</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'AvaliacaoEstagioProbatorio' }">Estágio Probatório</router-link>
                  </li>
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoRecadastro = !paraBaixoRecadastro">
                  Atualização Cadastral
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoRecadastro)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <router-link :to="{ name: 'MesCompetenciaOrdenado' }">Dados Pessoais</router-link>
                  </li>
                  <!--
                  <li>
                    <router-link :to="{ name: 'DependenteCpf' }"
                      >CPF's de Familiares</router-link
                    >
                  </li> -->
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoFerias = !paraBaixoFerias">
                  Férias
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoFerias)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <router-link :to="{ name: 'Ferias' }">Agendamento de Férias
                    </router-link>
                  </li>
                  <li v-if="ehResponsavelAprovador">
                    <router-link :to="{ name: 'Aprovacao' }">
                      Aprovação de Férias
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoFormulario = !paraBaixoFormulario">
                  Formulários
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoFormulario)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <router-link :to="{ name: 'FaltaLei' }">Falta Lei</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'DeclaracaoInclusaoImpostoRenda' }">Declaração de Inclusão
                      IR</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'DeclaracaoExclusaoImpostoRenda' }">Declaração de Exclusao
                      IR</router-link>
                  </li>
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoLinks = !paraBaixoLinks">
                  Links
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoLinks)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <a href="https://egov.santos.sp.gov.br/jornada" target="_blank">
                      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>&nbsp;Jornada
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf" target="_blank">
                      <i class="fa fa-book" aria-hidden="true"></i>&nbsp;Manual
                      Jornada
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx" target="_blank">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp;Anexo Único
                    </a>
                  </li>
                  <li>
                    <a href="https://entrega.santos.sp.gov.br" target="_blank">
                      <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;Entrega
                    </a>
                  </li>
                  <li>
                    <a href="https://webmail.santos.sp.gov.br" target="_blank" rel="noopener">
                      <i class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;WebMail
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/sigm_web_adm_sistema" target="_blank" rel="noopener">
                      <i class="fa fa-stethoscope" aria-hidden="true"></i>&nbsp;Perícia Médica
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                      <i class="fa fa-usd" aria-hidden="true"></i>&nbsp;Holerite
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                      <i class="fa fa-paw" aria-hidden="true"></i>&nbsp;Informe
                      de Rendimentos
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;Contagem de Tempo
                    </a>
                  </li>
                  <li>
                    <a href="https://egov.santos.sp.gov.br/legis/documents/55" target="_blank" rel="noopener">
                      <i class="fa fa-balance-scale" aria-hidden="true"></i>&nbsp;Estatuto
                    </a>
                  </li>
                  <li>
                    <a href="https://www.santos.sp.gov.br/portal/servidor" target="_blank" rel="noopener">
                      <i class="fa fa-globe" aria-hidden="true"></i>&nbsp;Portal
                      do Servidor
                    </a>
                  </li>
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
            </ul>
            <h3>
              Usuário
              <span style="font-size: 0.9em; font-weight: 700; color: #b9d8b3"
                v-if="autenticados && autenticados.length > 1">&nbsp; {{ funcionario.registroFormatado }}</span>
            </h3>
            <ul id="user-menu" class="nav navbar-nav">
              <li class="dropdown" v-if="autenticados && autenticados.length > 1">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" @click="paraBaixoTrocaRegistro = !paraBaixoTrocaRegistro">
                  Trocar Registro
                  <span class="to-the-right">
                    <i :class="downUp(paraBaixoTrocaRegistro)"></i>
                  </span>
                </a>
                <ul class="dropdown-menu" @click="toggleMenuLateral()">
                  <li>
                    <a href="#" v-for="user in autenticados" :key="user.id" @click="trocaRegistro(user)">
                      {{ user.registroFormatado }}
                    </a>
                  </li>
                  <li role="separator" class="divider"></li>
                </ul>
              </li>
              <li @click="toggleMenuLateral()">
                <a href="https://egov.santos.sp.gov.br/websshd" target="_blank" rel="noopener">Trocar Senha</a>
              </li>
              <li @click="toggleMenuLateral()">
                <router-link :to="{ name: 'Conta' }">Meus Dados</router-link>
              </li>
              <li style="margin-bottom: 32px" @click="toggleMenuLateral()">
                <router-link :to="{ name: 'Sair' }">Sair</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import BarraMenu from '@/components/barra-menu';

export default {
  name: 'barra-navegacao',

  data() {
    return {
      funcionario: this.$store.state.funcionario,
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      perfis: this.$store.state.usuarioLogado.perfis,
      overlaySuperior: false,
      overlayLateral: false,
      paraBaixoDeclaracao: true,
      paraBaixoRecadastro: true,
      paraBaixoAvaliacao: true,
      paraBaixoFerias: true,
      paraBaixoFormulario: true,
      paraBaixoLinks: true,
      paraBaixoTrocaRegistro: true
    };
  },
  props: {
    autenticado: {
      type: Boolean,
    },
    rotas: {
      type: Array,
      required: true,
    },
    usuario: {
      type: String,
      required: false,
    },
    sshd: {
      type: String,
      required: false,
    },
  },
  computed: {
    ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    registros() {
      return this.$store.state.usuarioLogado.funcionarios;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    },
  },
  watch: {
    registros(novo, anterior) {
      this.autenticados = novo;
    },
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
    permissoes(novo, anterior) {
      this.perfis = novo;
    },
  },
  methods: {
    toggleMenuSuperior() {
      const botao = document.querySelector('#btn-menu-superior');
      const largura = botao.clientWidth.toString();
      document.querySelector('#menu-superior').style.width = largura + 'px';
      const offCanvas = document.querySelector('.upper-off-canvas');
      if (offCanvas.classList.contains('fechado')) {
        botao.classList.remove('fechado');
        botao.classList.add('aberto');
        offCanvas.classList.remove('fechado');
        offCanvas.classList.add('aberto');
        this.overlaySuperior = true;
      } else if (offCanvas.classList.contains('aberto')) {
        botao.classList.remove('aberto');
        botao.classList.add('fechado');
        offCanvas.classList.remove('aberto');
        offCanvas.classList.add('fechado');
        this.overlaySuperior = false;
      } else {
        botao.classList.add('aberto');
        offCanvas.classList.add('aberto');
        this.overlaySuperior = true;
      }
      this.limpaSetas();
    },
    toggleMenuLateral() {
      const botao = document.querySelector('#btn-menu-lateral');
      const offCanvas = document.querySelector('.off-canvas');
      if (offCanvas.classList.contains('fechado')) {
        botao.classList.remove('fechado');
        botao.classList.add('aberto');
        offCanvas.classList.remove('fechado');
        offCanvas.classList.add('aberto');
        this.overlayLateral = true;
      } else if (offCanvas.classList.contains('aberto')) {
        botao.classList.remove('aberto');
        botao.classList.add('fechado');
        offCanvas.classList.remove('aberto');
        offCanvas.classList.add('fechado');
        this.overlayLateral = false;
      } else {
        botao.classList.add('aberto');
        offCanvas.classList.add('aberto');
        this.overlayLateral = true;
      }
      this.limpaSetas();
    },
    downUp(setaParaBaixo) {
      return setaParaBaixo ? 'fa fa-caret-down' : 'fa fa-caret-up';
    },
    limpaSetas() {
      this.paraBaixoDeclaracao = true;
      this.paraBaixoAvaliacao = true;
      this.paraBaixoRecadastro = true;
      this.paraBaixoFerias = true;
      this.paraBaixoFormulario = true;
      this.paraBaixoLinks = true;
      this.paraBaixoTrocaRegistro = true;
    },
    trocaRegistro(user) {
      this.funcionario = user;
      this.$store.commit('setFuncionario', user);
    },
  },
  components: {
    BarraMenu,
  },
};
</script>

<style scoped>
.front .navbar {
  margin-bottom: 0px;
  min-height: 53px;
  position: relative;
}

.navbar-default {
  background: #00615c none repeat scroll 0 0;
  border-bottom: 1px solid #004f4a;
  color: #ffffff;
  border-radius: 0;
}

.navbar .row {
  /* border-bottom: 1px solid #004f4a; */
  margin: 0;
}

.navbar-brand-topo {
  background-image: url(../../assets/LogoPMS.png);
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center left;
  text-indent: -999px;
  width: 100%;
}

.navbar-fixed-top {
  z-index: 1000;
}

.dropdown-menu>li>a {
  color: #468b35;
}

.dropdown-menu>li>a:hover,
.dropdown-menu>li>a:focus {
  text-decoration: none;
  color: #a1be4d;
  background-color: #eefceb;
}

.menu-header {
  background: #358a3f;
  margin-right: -15px;
  float: right;
  padding-right: 15px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.btntxt {
  float: left;
  margin: 0 10px 0 0;
  font-size: 1.4em;
}

.btnico {
  float: right;
  margin-top: 3px;
}

.btnico .icon-bar {
  background: #dae8d7;
  width: 25px;
  height: 4px;
  margin-bottom: 5px;
  transition: all 0.25s ease-in-out;
}

.show {
  display: block !important;
}

.off-canvas {
  position: absolute;
  top: 56px;
  right: 0px;
  overflow: auto;
  width: 0;
  height: 100vh;
}

.off-canvas.aberto {
  animation-name: menu-lateral-aberto;
  animation-duration: 0.3s;
  width: 300px;
}

.off-canvas.fechado {
  animation-name: menu-lateral-fechado;
  animation-duration: 0.3s;
  width: 0;
}

#navbar {
  margin-bottom: 0;
  min-height: 53px;
}

#overlay {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.2);
}

#btn-menu-lateral {
  margin: 0 -15px 0 0;
  border: 0;
  background-color: #468c36;
  color: #dae8d7;
  float: right;
  height: 55px;
  border-radius: 0;
  padding-left: 20px;
  padding-right: 20px;
}

#btn-menu-lateral.aberto .btnico .icon-bar:nth-child(1) {
  -webkit-transform: rotate(45deg) translate(5px, 4px);
  transform: rotate(45deg) translate(8px, 4px);
}

#btn-menu-lateral.aberto .btnico .icon-bar:nth-child(2) {
  opacity: 0;
}

#btn-menu-lateral.aberto .btnico .icon-bar:nth-child(3) {
  -webkit-transform: rotate(-45deg) translate(4px, -4px);
  transform: rotate(-45deg) translate(8px, -5px);
}

#menu-lateral {
  background-color: #fff;
  padding: 15px 15px 0px 20px;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-radius: 0 0 5px 5px;
  min-height: 100%;
  overflow-y: auto;
}

#menu-lateral h3 {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.1;
  font-size: 1.8em;
  color: #dae8d7;
  margin-top: 20px;
  margin-bottom: 10px;
}

#menu-lateral ul,
ol,
dl {
  font-weight: 400;
  margin: 0 0 2.2rem;
  list-style-position: inside;
}

#menu-lateral li a {
  line-height: 2.6rem;
  padding: 3px 10px;
  font-size: 1.05em;
  color: #468b35;
  text-decoration: none;
}

#menu-lateral .dropdown-menu li,
#main-menu .dropdown-menu li {
  padding-left: 13px;
  width: 98%;
}

.nav li a:focus,
.nav li a:active,
.nav li a:visited,
.nav li a:hover {
  background-color: #eefceb;
  text-decoration: none;
  color: #a1be4d;
}

.navbar-default .navbar-nav>.open>a,
.navbar-default .navbar-nav>.open>a:hover,
.navbar-default .navbar-nav>.open>a:focus {
  background-color: #eefceb;
  text-decoration: none;
  color: #a1be4d;
}

.dropdown-menu .divider {
  margin: 9px 0 -15px 0;
}

.to-the-right {
  float: right;
}

@keyframes menu-lateral-fechado {
  0% {
    width: 300px;
  }

  100% {
    width: 0;
  }
}

@keyframes menu-lateral-aberto {
  0% {
    width: 0;
  }

  100% {
    width: 300px;
  }
}

@media screen and (min-width: 768px) {
  .container {
    margin-right: 0;
    width: 100%;
  }

  .upper-off-canvas {
    position: absolute;
    top: 56px;
    right: -15px;
    overflow: hidden;
    height: 0;
  }

  .upper-off-canvas.aberto {
    animation-name: menu-superior-aberto;
    animation-duration: 0.3s;
    height: fit-content;
  }

  .upper-off-canvas.fechado {
    animation-name: menu-superior-fechado;
    animation-duration: 0.3s;
    height: 0;
  }

  #btn-menu-superior {
    margin: 0 -30px 0 0;
    border: 0;
    background-color: #468c36;
    color: #dae8d7;
    float: right;
    height: 55px;
    border-radius: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  #btn-menu-superior.aberto .btnico .icon-bar:nth-child(1) {
    -webkit-transform: rotate(45deg) translate(5px, 4px);
    transform: rotate(45deg) translate(8px, 4px);
  }

  #btn-menu-superior.aberto .btnico .icon-bar:nth-child(2) {
    opacity: 0;
  }

  #btn-menu-superior.aberto .btnico .icon-bar:nth-child(3) {
    -webkit-transform: rotate(-45deg) translate(4px, -4px);
    transform: rotate(-45deg) translate(8px, -5px);
  }

  #menu-superior {
    background-color: #fff;
    padding: 15px 0px 0px 15px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-radius: 0 0 5px 5px;
  }

  #menu-superior h3 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    font-size: 1.8em;
    color: #dae8d7;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  #menu-superior ul,
  ol,
  dl {
    font-weight: 400;
    line-height: 2.4rem;
    margin: 0 0 2.2rem;
    list-style-position: inside;
  }

  #menu-superior li a {
    padding: 3px 10px;
    font-size: 1.05em;
    color: #468b35;
    text-decoration: none;
  }

  #menu-lateral .navbar-nav {
    float: none;
  }

  #menu-lateral li {
    float: none;
  }

  #menu-lateral .dropdown-menu,
  #main-menu .dropdown-menu {
    position: relative;
    border: unset;
    box-shadow: unset;
    width: 98%;
  }

  @keyframes menu-superior-fechado {
    0% {
      height: 200px;
    }

    100% {
      height: 0;
    }
  }

  @keyframes menu-superior-aberto {
    0% {
      height: 0;
    }

    100% {
      height: 200px;
    }
  }
}

@media screen and (min-width: 992px) {
  .container {
    margin-right: auto;
    width: 970px;
  }

  #btn-menu-superior {
    margin: 0 -15px 0 0;
    border: 0;
    background-color: #468c36;
    color: #dae8d7;
    float: right;
    height: 55px;
    border-radius: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  .upper-off-canvas {
    position: absolute;
    top: 56px;
    right: 0px;
    overflow: hidden;
    height: 0;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?06210e44